<template>
	<div v-if="loggedIn" class="user-actions pull-right">
		<span>Welcome back {{username}}</span><a v-on:click="logout" class="fancy-link">logout</a>
	</div>
</template>
<script>
import auth from '../services/auth'
export default {
	computed: {
		loggedIn () {
			return this.$store.state.user.authenticated
		},
		username () {
			return this.$store.state.user.name
		}
	},
	methods: {
		logout (e) {
			e.preventDefault()
			auth.logout()
		}
	}
}
</script>
<style>
.user-actions{
	margin: 15px 10px 0 0;
	color: #ffffff;
}
.user-actions a{
	color:#ffffff;
	cursor: pointer;
	margin-left:20px;
}
.user-actions a:hover{
	color:#ffffff;
}
</style>


// WEBPACK FOOTER //
// UserActions.vue?5be90d5c